import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { IWorkContext, IWorkItem, IWorkItemDto, IWorkItemEvent, IWorkItemNote } from 'src/app/models/work-items';
import { ConfigurationService } from '../configuration/configuration.service';
import { EndpointFactory } from '../endpoint-factory.service';
import { catchError } from 'rxjs/operators';
import { Observable, firstValueFrom } from 'rxjs';
import { IWorkItemSettingsResponse } from 'src/app/models/application';

@Injectable({
  providedIn: 'root'
})
export class WorkItemEndpointService extends EndpointFactory {

  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
      super(http, configurations, injector, '', configurations.webAppApiBaseUrl);
  }

  getWorkItemsEvents(tenantId: string, Id: number): Observable<IWorkItemEvent[]> {

    const url = `${this.url}workitem/${tenantId}/event/${Id}`;

    return this.http.get<IWorkItemEvent[]>(url).pipe(
        catchError(error => {
            return this.handleError(error);
        }));
  }

  getWorkItemsByUserName(userName: string, status: string, type: string): Promise<IWorkContext> {

    let url = `${this.url}workitem/assigned/?username=${userName}`;

    if(status && type) {
      url = `${this.url}workitem/assigned/?username=${userName}&status=${status}&type=${type}`;
    } else if(status) {
        url = `${this.url}workitem/assigned/?username=${userName}&status=${status}`;
    } else if(type) {
      url = `${this.url}workitem/assigned/?username=${userName}&type=${type}`;
    }

    return this.http.get<IWorkContext>(url).pipe(
        catchError(error => {
            return this.handleError(error);
        })).toPromise();
  }

  getWorkItemsByUniqueId(uniqueId: string, status: string, type: string): Promise<IWorkContext> {

    let url = `${this.url}workitem/assigned/details/?uniqueId=${uniqueId}`;

    if(status && type) {
      url = `${this.url}workitem/assigned/details/?uniqueId=${uniqueId}&status=${status}&type=${type}`;
    } else if(status) {
        url = `${this.url}workitem/assigned/details/?uniqueId=${uniqueId}&status=${status}`;
    } else if(type) {
      url = `${this.url}workitem/assigned/details/?uniqueId=${uniqueId}&type=${type}`;
    }

    return this.http.get<IWorkContext>(url).pipe(
        catchError(error => {
            return this.handleError(error);
        })).toPromise();
  }

    getAssociatedWorkItemsByUniqueId(uniqueId: string, status: string, type: string): Promise<IWorkContext> {

    let url = `${this.url}workitem/associated/details/?uniqueId=${uniqueId}`;

    if(status && type) {
      url = `${this.url}workitem/associated/details/?uniqueId=${uniqueId}&status=${status}&type=${type}`;
    } else if(status) {
        url = `${this.url}workitem/associated/details/?uniqueId=${uniqueId}&status=${status}`;
    } else if(type) {
      url = `${this.url}workitem/associated/details/?uniqueId=${uniqueId}&type=${type}`;
    }

    return this.http.get<IWorkContext>(url).pipe(
        catchError(error => {
            return this.handleError(error);
        })).toPromise();
  }

  getWorkItemsById(tenantId: string, id: number): Promise<IWorkContext> {

    let url = `${this.url}workitem/${id}/${tenantId}`;

    return firstValueFrom(this.http.get<IWorkContext>(url).pipe(
      catchError(error => {
          return this.handleError(error);
      })
    ));
  }

  getWorkItemsByMember(tenantId: string, memberId: string, status: string, type: string): Promise<IWorkContext> {

    let url = `${this.url}workitem/${tenantId}/member/${memberId}/details`;

    if(status && type) {
        url = `${this.url}workitem/${tenantId}/member/${memberId}/details/?status=${status}&type=${type}`;
      } else if(status) {
          url = `${this.url}workitem/${tenantId}/member/${memberId}/details/?status=${status}`;
      } else if(type) {
        url = `${this.url}workitem/${tenantId}/member/${memberId}/details/?type=${type}`;
      }

    return this.http.get<IWorkContext>(url).pipe(
        catchError(error => {
            return this.handleError(error);
        })).toPromise();
  }

  createWorkItem(tenantId: string, workitem: IWorkItemDto): Promise<IWorkItemDto> {
    const url = `${this.url}workitem/${tenantId}/create`;

    return this.http.post<IWorkItemDto>(url, workitem).pipe(
      catchError(error => {
          return this.handleError(error);
      })).toPromise();
  }

  updateWorkItems(tenantId: string, status: string, workitem: IWorkItemDto): Observable<{ result: boolean }> {
    const url = `${this.url}workitem/${tenantId}/${status}/update`;

    return this.http.post<{ result: boolean }>(url, workitem).pipe(
      catchError(error => {
          return this.handleError(error);
      }));
  }

  assignWorkItem(tenantId: string, id: number, userObjectId: string): Promise<IWorkItemDto> {
    const url = `${this.url}workitem/${tenantId}/${id}/assign/${userObjectId}`;

    return firstValueFrom(this.http.put<IWorkItemDto>(url, null).pipe(
      catchError(error => {
          return this.handleError(error);
      })));
  }

  saveWorkItemSettings(tenantId: string, Id: number, request: any): Promise<IWorkItemSettingsResponse>  {
    const url = `${this.url}workitem/${tenantId}/${Id}/metadata`;

    return this.http.post<IWorkItemSettingsResponse>(url, request).pipe(
      catchError(error => {
          return this.handleError(error);
      })).toPromise();
  }

  addWorkItemNote(tenantId: string, workItemId: number, note: IWorkItemNote): Observable<{ result: number }> {
    const url = `${this.url}workitem/${tenantId}/${workItemId}/note`;

    return this.http.post<{ result: number }>(url, note).pipe(
      catchError(error => {
          return this.handleError(error);
      }));
  }

  getWorkItemContext(tenantId: string, work: IWorkItem): Observable<IWorkItem> {

    const url = `${this.url}workitem/${tenantId}/context`;

    return this.http.post<IWorkItem>(url, work).pipe(
      catchError(error => {
          return this.handleError(error);
      }));
  }
}
